import { render, staticRenderFns } from "./ManagePracticeRole.vue?vue&type=template&id=1a7c4e6e&scoped=true"
import script from "./ManagePracticeRole.vue?vue&type=script&lang=js"
export * from "./ManagePracticeRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7c4e6e",
  null
  
)

export default component.exports